import { PartnerPentestStatistics } from '../partner-pentest-statistics';
import { CustomerLightData } from '../customer-light.data';

export interface PartnerDashboardState {
  partnerPentestScanStatistics: PartnerPentestStatistics[];
  customersLight: CustomerLightData[];
  partnerPentestScanStatisticsLoading: boolean;
  customersLightLoading: boolean;
}

export const initialPartnerDashboardState: PartnerDashboardState = {
  partnerPentestScanStatistics: [],
  customersLight: [],
  partnerPentestScanStatisticsLoading: true,
  customersLightLoading: true,
};
